export function getAdditionalSizeNumber(length?: number) {
  if (length) {
    if (length > 2) {
      const base = 1.4;
      const step = 0.05;

      return length * (base - (length - 3) * step);
    }

    return 0;
  }

  return 0;
}
